import React, { useEffect, useState } from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { usePostVideoStatementViewMutation } from '../../api/usePostVideoStatementViewMutation';
import { StyledIframe } from './VideoModal.style';
import { useRouteParams } from '../../hooks/useRouteParams';
import { EntityDTO } from '../../DocumentVault.meta';

interface VideoModalProps {
  entity: EntityDTO | null;
  onClose(): void;
}

export const VideoModal = ({ entity, onClose }: VideoModalProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const { mutateAsync } = usePostVideoStatementViewMutation();

  const { clientId } = useRouteParams();

  useEffect(() => {
    if (entity !== null) {
      setIsLoading(true);

      mutateAsync({ videoName: entity.name, clientId });
    }
  }, [entity, mutateAsync, clientId]);

  return (
    <Modal isOpen={entity !== null} size="large">
      <Box height={447} display="flex" alignItems="center" justifyContent="center">
        {isLoading && <Loading text="Loading video statement" />}

        <StyledIframe
          onLoad={() => setIsLoading(false)}
          title={entity?.name}
          src={entity?.objectUrl ?? undefined}
          isLoading={isLoading}
          allow="fullscreen https://testvideo.orionadvisor.com https://test.orionadvisor.com"
        />
      </Box>

      <ModalFooter>
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};
